import React from 'react';
import { useTranslation } from "react-i18next";
import ManageCarousel from './ManageCarousel';
import ManageBlocks from './ManageBlocks';

function ManageHomepage() {
    const { t } = useTranslation();
    return (
        <div>
            <h2>{t("manage_homepage_title")}</h2>
            <hr />
            <ManageCarousel />
            <hr />
            <ManageBlocks />
        </div>
    );
}

export default ManageHomepage;
